import OrdersListIcon from '../../assets/images/customSideBar/OrdersListIcon';
import Pills from '../../assets/images/customSideBar/Pills';
import Smile from '../../assets/images/customSideBar/Smile';
import BordOneToneIcon from '../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import { BACKOFFICE_MODULES } from 'types/configuration.types';
import { bordColorTheme, fgDefault } from 'styles/styles.constants';

export const getOperationsModule = (selectedModule: string, onlyDevelopers?: boolean) => {
  const isMainModuleSelected = selectedModule === 'operations';

  return {
    mainModule: {
      img: (
        <BordOneToneIcon
          variant="hierarchy"
          stroke={isMainModuleSelected ? bordColorTheme.white[50] : fgDefault}
          customWidth="18px"
        />
      ),
      name: 'operations',
      title: 'Operaciones',
      show: true
    },
    subModules: [
      {
        img: (
          <BordOneToneIcon
            variant="menu"
            stroke={selectedModule === 'order' ? bordColorTheme.white[50] : fgDefault}
            customWidth="18px"
          />
        ),
        name: 'order',
        title: 'Órdenes',
        route: '/order/shopping',
        show: true
      },
      {
        img: (
          <BordOneToneIcon
            variant="menu"
            stroke={
              selectedModule === 'trackingOrder'
                ? bordColorTheme.white.default
                : bordColorTheme.navyBlue[900]
            }
            customWidth="18px"
          />
        ),
        name: 'trackingOrder',
        title: 'Tracking Order',
        route: '/tracking-order/main',
        show: onlyDevelopers
      },
      {
        img: (
          <BordOneToneIcon
            variant="truck"
            stroke={selectedModule === 'logisticService' ? bordColorTheme.white[50] : fgDefault}
            customWidth="18px"
          />
        ),
        name: 'logisticService',
        title: 'Servicios logs.',
        route: '/logistic-service/listing',
        show: true
      },
      {
        img: (
          <BordOneToneIcon
            variant="shop"
            stroke={selectedModule === 'stock' ? bordColorTheme.white[50] : fgDefault}
            customWidth="18px"
            className="stockOrderIcon"
          />
        ),
        name: 'stock',
        title: 'Stock propio',
        route: '/stock/list-stock',
        show: true
      }
    ].filter(module => module.show)
  };
};

/**
 * Obtiene la configuración del módulo "Catálogo" con sus sub-módulos
 */
export const getCatalogModule = (selectedModule: string, onlyDevelopers?: boolean) => {
  const isMainModuleSelected = selectedModule === 'catalogGroup';

  return {
    mainModule: {
      img: (
        <BordOneToneIcon
          variant="openBook"
          stroke={isMainModuleSelected ? bordColorTheme.white[50] : fgDefault}
          customWidth="18px"
        />
      ),
      name: 'catalogGroup',
      title: 'Catálogo',
      show: true
    },
    subModules: [
      {
        img: (
          <BordOneToneIcon
            variant="caps"
            stroke={selectedModule === 'catalog' ? bordColorTheme.white[50] : fgDefault}
            customWidth="18px"
          />
        ),
        name: 'catalog',
        title: 'Catálogo',
        route: '/catalog/product-list',
        show: true
      },
      {
        img: (
          <BordOneToneIcon
            variant="star"
            stroke={selectedModule === 'brand' ? bordColorTheme.white[50] : fgDefault}
            customWidth="18px"
          />
        ),
        name: 'brand',
        title: 'Marcas',
        route: '/brand/list',
        show: true
      }
    ].filter(module => module.show)
  };
};

/**
 * Obtiene los módulos simples del sidebar (sin sub-módulos)
 */
export const getSimpleSidebarModules = (selectedModule: string, onlyDevelopers?: boolean) => [
  {
    img: (
      <BordOneToneIcon
        variant="home"
        stroke={selectedModule === 'dashboard' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'dashboard',
    title: 'Home',
    route: '/dashboard',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="monitor"
        stroke={selectedModule === 'tools' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'tools',
    title: 'Herramientas',
    route: '/tools/listing',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="billing"
        stroke={selectedModule === 'billing' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
        className="billingIcon"
      />
    ),
    name: 'billing',
    title: 'Facturación',
    route: '/billing/listing',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="business"
        fill={selectedModule === 'organization' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
        className="organizationIcon"
      />
    ),
    name: 'organization',
    title: 'Empresas',
    route: '/organization/list',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="countries"
        stroke={selectedModule === 'country' ? bordColorTheme.white[50] : fgDefault}
        fill={selectedModule === 'country' ? fgDefault : bordColorTheme.white[50]}
        customWidth="18px"
      />
    ),
    name: 'country',
    title: 'Países',
    route: '/country/listing',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="download"
        customWidth="18px"
        stroke={selectedModule === 'bulkUpload' ? bordColorTheme.white[50] : fgDefault}
      />
    ),
    name: 'bulkUpload',
    title: 'Cargue masivo',
    route: '/bulk-upload/type-of-charge',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="megaPhone"
        className='megaPhoneIcon'
        stroke={selectedModule === 'announcement' ? bordColorTheme.white[50] : fgDefault}
        fill={selectedModule === 'announcement' ? fgDefault : bordColorTheme.white[50]}
        customWidth="18px"
      />
    ),
    name: 'announcement',
    title: 'Anuncios',
    route: '/announcement',
    show: true
  }
];

/**
 * Obtiene los módulos del footer (configuración, soporte, logout)
 */
export const getFooterModules = (selectedModule: string, onlyDevelopers?: boolean) => [
  {
    img: (
      <BordOneToneIcon
        variant="settings"
        stroke={selectedModule === 'configuration' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'configuration',
    title: 'Configuración',
    route: '/configuration/details',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="headphones"
        stroke={selectedModule === 'opsSupport' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'opsSupport',
    title: 'Soporte',
    route: '/ops-support/start',
    show: onlyDevelopers
  },
  {
    img: (
      <BordOneToneIcon
        variant="logOut"
        stroke={selectedModule === 'logout' ? bordColorTheme.white[50] : fgDefault}
        customWidth="16px"
      />
    ),
    title: 'Cerrar sesión',
    name: 'logout',
    show: true
  }
];

/**
 * Función legacy para mantener compatibilidad con BackofficeSidebar
 */
export const getSidebarModules = (selectedModule: string, onlyDevelopers?: boolean) => [
  {
    img: (
      <BordOneToneIcon
        variant="home"
        stroke={selectedModule === 'dashboard' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'dashboard',
    title: 'Home',
    route: '/dashboard',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="business"
        fill={selectedModule === 'organization' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
        className="organizationIcon"
      />
    ),
    name: 'organization',
    title: 'Empresas',
    route: '/organization/list',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="openBook"
        stroke={selectedModule === 'catalog' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'catalog',
    title: 'Catálogo',
    route: '/catalog/product-list',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="countries"
        stroke={selectedModule === 'country' ? bordColorTheme.white[50] : fgDefault}
        fill={selectedModule === 'country' ? fgDefault : bordColorTheme.white[50]}
        customWidth="18px"
      />
    ),
    name: 'country',
    title: 'Países',
    route: '/country/listing',
    show: true
  },
  {
    img:
      selectedModule === 'order' ? (
        <OrdersListIcon className="orderIcon" stroke={bordColorTheme.white[50]} />
      ) : (
        <OrdersListIcon className="orderIcon" stroke={fgDefault} />
      ),
    name: 'order',
    title: 'Órdenes',
    route: '/order/shopping',
    show: true
  },
  {
    img: (
      <OrdersListIcon
        className="orderIcon"
        stroke={
          selectedModule === BACKOFFICE_MODULES.TRACKING_ORDER
            ? bordColorTheme.white.default
            : bordColorTheme.navyBlue[900]
        }
      />
    ),
    name: 'trackingOrder',
    title: 'Tracking Order',
    route: '/tracking-order/main',
    show: onlyDevelopers
  },
  {
    img: (
      <BordOneToneIcon
        variant="shop"
        stroke={selectedModule === 'stock' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
        className="stockOrderIcon"
      />
    ),
    name: 'stock',
    title: 'Órdenes stock',
    route: '/stock/list-stock',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="truck"
        stroke={selectedModule === 'logisticService' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'logisticService',
    title: 'Servicios logs.',
    route: '/logistic-service/listing',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="billing"
        stroke={selectedModule === 'billing' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'billing',
    title: 'Facturación',
    route: '/billing/listing',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="monitor"
        stroke={selectedModule === 'tools' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'tools',
    title: 'Herramientas',
    route: '/tools/listing',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="download"
        customWidth="18px"
        stroke={selectedModule === 'bulkUpload' ? bordColorTheme.white[50] : fgDefault}
      />
    ),
    name: 'bulkUpload',
    title: 'Cargue Masivo',
    route: '/bulk-upload/type-of-charge',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="paymentRequest"
        stroke={selectedModule === 'paymentRequest' ? bordColorTheme.white[50] : fgDefault}
        fill={selectedModule === 'paymentRequest' ? fgDefault : bordColorTheme.white[50]}
        customWidth="18px"
        strokeWidth={1}
      />
    ),
    name: 'paymentRequest',
    title: 'Solicitar Pagos',
    route: '',
    externalRoute: 'https://finance.bord.co/',
    show: true
  },
  {
    img: (
      <BordOneToneIcon
        variant="star"
        stroke={selectedModule === 'brand' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'brand',
    title: 'Marcas',
    route: '/brand/list',
    show: true
  },
  {
    img:
      selectedModule === 'category' ? (
        <Pills className="categoryIcon" />
      ) : (
        <Pills className="categoryIcon" fill={bordColorTheme.white[50]} stroke={fgDefault} />
      ),
    name: 'category',
    title: 'Categorías',
    route: '/category/modify-pills',
    show: onlyDevelopers
  },
  {
    img: (
      <BordOneToneIcon
        variant="settings"
        stroke={selectedModule === 'configuration' ? bordColorTheme.white[50] : fgDefault}
        customWidth="18px"
      />
    ),
    name: 'configuration',
    title: 'Configuración',
    route: '/configuration/details',
    show: true
  },
  {
    img: <Smile className="homeIcon" fill={selectedModule === 'opsSupport' ? bordColorTheme.white[50] : ''} />,
    name: 'opsSupport',
    title: 'Soporte',
    route: '/ops-support/start',
    show: onlyDevelopers
  },
  {
    img: (
      <BordOneToneIcon
        variant="megaPhone"
        stroke={selectedModule === 'announcement' ? bordColorTheme.white[50] : fgDefault}
        fill={selectedModule === 'announcement' ? fgDefault : bordColorTheme.white[50]}
        customWidth="18px"
      />
    ),
    name: 'announcement',
    title: 'Anuncios',
    route: '/announcement',
    show: true
  },
  {
    img: <Smile className="homeIcon" fill={selectedModule === 'home' ? bordColorTheme.white[50] : ''} />,
    name: 'home',
    show: false
  }
];

export interface IsidebarModule {
  img: JSX.Element;
  name: string;
  title?: string;
  route?: string;
  show?: boolean;
  externalRoute?: string;
}

export interface IExpandableModuleGroup {
  mainModule: IsidebarModule;
  subModules: IsidebarModule[];
}
